import { useState } from 'react';

import DeactivateUserForm from '@/components/forms/user/update-user/DeactivateUserForm';
import UpdateUserDataForm from '@/components/forms/user/update-user/UpdateUserDataForm';
import UpdateUserPasswordForm from '@/components/forms/user/update-user/UpdateUserPasswordForm';
import Button from '@/components/ui/button';
import { useUser } from '@/hooks/useUser';

const SettingsDashboard = () => {
	const { user, isLoading: userIsLoading, refetch: refetchUser } = useUser();
	const [selectedForm, setSelectedForm] = useState('user-data');

	const handleSelectForm = (form: string) => {
		setSelectedForm(form);
	};

	return (
		<div className="flex flex-col gap-5">
			<div className="flex gap-3 flex-wrap">
				<div>
					{user && !userIsLoading && (
						<div className="flex flex-col h-full grow gap-4">
							<div className="flex flex-row gap-x-2">
								<Button
									color="white"
									className="border !border-grey-30"
									shape="rounded"
									transition="none"
									onClick={() => handleSelectForm('user-data')}
									data-test="update-data-modal-button"
									disabled={selectedForm === 'user-data'}
								>
									Update Personal Data
								</Button>
							</div>
						</div>
					)}
				</div>

				<div>
					{user && !userIsLoading && (
						<div className="flex flex-col h-full grow gap-4">
							<div className="flex flex-row gap-x-2">
								<Button
									color="white"
									className="border !border-grey-30"
									shape="rounded"
									transition="none"
									onClick={() => handleSelectForm('user-password')}
									data-test="update-password-modal-button"
									disabled={selectedForm === 'user-password'}
								>
									Update Password
								</Button>
							</div>
						</div>
					)}
				</div>

				<div>
					{user && !userIsLoading && (
						<div className="flex flex-col h-full grow gap-4">
							<div className="flex flex-row gap-x-2">
								<Button
									color="danger"
									shape="rounded"
									transition="none"
									onClick={() => handleSelectForm('user-deactivate')}
									disabled={selectedForm === 'user-deactivate'}
									className="border !border-grey-30 disabled:text-black"
									data-test="deactivate-account-button"
								>
									Deactivate Account
								</Button>
							</div>
						</div>
					)}
				</div>
			</div>

			<div>
				<div className="w-[50%] min-w-[350px]">
					{selectedForm === 'user-data' && (
						<UpdateUserDataForm
							initialValues={{ name: user?.name ?? '' }}
							refetchUser={refetchUser}
						/>
					)}
				</div>

				<div className="w-[50%] min-w-[350px]">
					{selectedForm === 'user-password' && (
						<UpdateUserPasswordForm refetchUser={refetchUser} />
					)}
				</div>

				<div className="w-[50%] min-w-[350px]">
					{selectedForm === 'user-deactivate' && (
						<DeactivateUserForm refetchUser={refetchUser} />
					)}
				</div>
			</div>
		</div>
	);
};
export default SettingsDashboard;
